import { plural } from 'lib/plural';
import React from 'react';
import { isAlbum } from 'reactApp/modules/albums/albums.types';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { filesPlural } from 'reactApp/utils/pluralHelpers';
import { truncateTextMiddle } from 'reactApp/utils/textHelpers';

const isMobile = EnvironmentSelectors.isMobile();

export const foldersPlural = (count: number): string => ['выбранную папку', 'выбранные папки', 'выбранных папок'][plural(count)];
export const filePlural = (count: number): string => ['выбранный файл', 'выбранных файла', 'выбранных файлов'][plural(count)];
const getItemType = (item) => {
    if (item.type === 'album') {
        return 'альбом';
    }

    return item.isFolder ? 'папку' : 'файл';
};

const getItemsCount = (items) => {
    return items.reduce(
        (result, item) => {
            if (item.isFolder) {
                result.folderCount++;
            } else {
                result.fileCount++;
            }

            return result;
        },
        { folderCount: 0, fileCount: 0 }
    );
};

const getAlbumItemsContent = (items) => {
    if (items.length === 1) {
        const itemName = isMobile ? truncateTextMiddle(items[0].name, 20) : items[0].name;

        return `Вы действительно хотите убрать «${itemName}» из альбома? Файл из Облака удалён не будет.`;
    }

    return `Вы действительно хотите убрать файлы из альбома? Файлы из Облака удалены не будут.`;
};

export const getContent = ({ isMounted, items, hasAlienFiles }) => {
    const { folderCount, fileCount } = getItemsCount(items);
    const isAlbumFiles = items.length && items.every((item) => item.storage === EStorageType.albums && !isAlbum(item));

    if (isAlbumFiles) {
        return getAlbumItemsContent(items);
    }

    const aliensFiles = hasAlienFiles && (
        <>
            Вы не можете удалять чужие файлы и папки.
            <br />
        </>
    );

    if (items.length === 1) {
        const itemName = isMobile ? truncateTextMiddle(items[0].name, 20) : items[0].name;

        if (isMounted) {
            return `${folderCount ? 'Удаляемая папка' : 'Удаляемый файл'} «${itemName}» находится в общей папке, при удалении ${
                folderCount ? 'она будет перемещена' : 'он будет перемещён'
            } в Корзину владельца.`;
        }

        return (
            <>
                {aliensFiles}
                Вы действительно хотите удалить {getItemType(items[0])} «{itemName}»?
            </>
        );
    }

    if (isMounted) {
        return `Удаляемые ${fileCount ? 'файлы ' : ''}${fileCount && folderCount ? 'и ' : ''}${
            folderCount ? 'папки ' : ''
        } находятся в общей папке, при удалении они будут перемещены в Корзину владельца.`;
    }

    let content = folderCount ? `${folderCount} ${foldersPlural(folderCount)} ` : '';
    content += fileCount && folderCount ? 'и ' : '';
    content += fileCount ? `${fileCount} ${folderCount ? filesPlural(fileCount) : filePlural(fileCount)}` : '';

    return (
        <>
            {aliensFiles}
            {content && <>Вы действительно хотите удалить {content.trim()}?</>}
        </>
    );
};

export const renderRemoveDialog = (data) => openPopupHelper({ popupName: popupNames.REMOVE_DIALOG, data });
